import React, { useRef, useState, useEffect, useCallback } from "react";
import {
  Title,
  Paper,
  TextInput,
  Button,
  Card,
  SimpleGrid,
  ThemeIcon,
  ActionIcon,
  LoadingOverlay,
  Autocomplete,
} from "@mantine/core";
import { Refresh, Camera, CameraPlus } from "tabler-icons-react";
import authAxios from "../keycloak/authAxios";
import * as faceapi from "face-api.js";
import { trueInsert, alertNotify } from "../Notify/notifyMe";
import { customLoader } from "../theme/loader";

const AddPerson = () => {
  // Form
  const nameRef = useRef();
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [location, setLocation] = useState("");
  // ShutterImage
  const [toggle, setToggle] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const faceLocationUpdater = useRef(null);
  const [canDetecte, setCanDetecae] = useState(false);
  const cameraStream = useRef(null);
  const faceShutterTimer = useRef(null);
  const [faceImage, setFaceImage] = useState(null);
  const [faceFound, setFoundFace] = useState(false);
  const [loading, setLoading] = useState(false);
  const [Flag, setFlag] = useState("");

  useEffect(() => {
    const MODEL_URL = process.env.PUBLIC_URL + "/models";
    Promise.all([
      faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
      faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
      faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
      faceapi.nets.faceExpressionNet.loadFromUri(MODEL_URL),
    ]);
    if (nameRef.current !== undefined && nameRef.current !== null) {
      return nameRef.current.focus();
    }
  }, []);
  const onPlay = () => {
    const canvas = canvasRef.current;
    const displaySize = {
      width: videoRef.current.width,
      height: videoRef.current.height,
    };
    faceapi.matchDimensions(canvas, displaySize);
    faceLocationUpdater.current = setInterval(async () => {
      if (canDetecte === true) {
        const detections = await faceapi.detectAllFaces(
          videoRef.current,
          new faceapi.TinyFaceDetectorOptions()
        );
        const resizedDetections = faceapi.resizeResults(
          detections,
          displaySize
        );
        canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
        faceapi.draw.drawDetections(canvas, resizedDetections);
      }
    }, 50);
  };
  const stopCamera = () => {
    faceShutterTimer.current = null;
    clearInterval(faceLocationUpdater.current);

    videoRef.current.pause();

    cameraStream.current.getTracks().forEach(function (track) {
      if (track.readyState === "live") {
        track.stop();
      }
    });
  };
  const captureImage = () => {
    if (faceImage == null) {
      const canvas = canvasRef.current;
      canvas
        .getContext("2d")
        // Dimensions of snaping image relative to the video
        .drawImage(videoRef.current, 0, 0, 500, 500);
      setFaceImage(canvas.toDataURL("image/jpeg"));

      setFoundFace(true);
      setCanDetecae(false);
      stopCamera();
    }
  };
  function startVideo() {
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: false })
      .then(function (stream) {
        cameraStream.current = stream;
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      })
      .catch(function (err) {
        console.log("An error occurred: " + err);
      });
  }

  const handleAddPerson = useCallback(() => {
    if ((location === "") | (Flag === "") | (faceImage === null)) {
      return alertNotify("الرجاء ادخال المعلومات المطلوبة");
    }

    setLoading(true);

    const paload = {
      full_name: name === "" ? "غير معروف" : name,
      phone_number: phoneNumber === "" ? "غير معروف" : phoneNumber,
      address: address === "" ? "غير معروف" : address,
      flag: Flag === "مفقود" ? "LOST" : "FOUND",
      photo: [faceImage],
    };

    authAxios
      .post(`arshad`, paload)
      .then((res) => {
        if (res.data.result) {
          setLoading(false);
          trueInsert(faceImage, name, phoneNumber);
        } else {
          setLoading(false);
          alertNotify("لم يتم اضافة الشخص");
        }
      })
      .catch((e) => {
        setLoading(false);
        alertNotify("لم يتم اضافة الشخص");
        console.log(e.response.data);
      });
  }, [name, address, location, phoneNumber, faceImage, Flag]);
  return (
    <>
      <SimpleGrid
        cols={2}
        spacing="xs"
        breakpoints={[{ maxWidth: "sm", cols: 1 }]}
      >
        <ShutterImage
          toggle={toggle}
          setToggle={setToggle}
          setCanDetecae={setCanDetecae}
          setFaceImage={setFaceImage}
          startVideo={startVideo}
          stopCamera={stopCamera}
          onPlay={onPlay}
          canvasRef={canvasRef}
          videoRef={videoRef}
          captureImage={captureImage}
          faceImage={faceImage}
        />
        <Form
          nameRef={nameRef}
          name={name}
          setName={setName}
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          address={address}
          setAddress={setAddress}
          location={location}
          setLocation={setLocation}
          handleAddPerson={handleAddPerson}
          faceImage={faceImage}
          Flag={Flag}
          setFlag={setFlag}
        />
      </SimpleGrid>
      {loading && (
        <div>
          <LoadingOverlay
            loader={customLoader}
            visible
            pb={75}
            overlayBlur={1.5}
          />
        </div>
      )}
    </>
  );
};

export default AddPerson;

function Form({
  nameRef,
  name,
  setName,
  phoneNumber,
  setPhoneNumber,
  address,
  setAddress,
  location,
  setLocation,
  handleAddPerson,
  faceImage,
  setFlag,
  Flag,
}) {
  return (
    <Card mt={60}>
      <Title
        align="center"
        sx={(theme) => ({
          fontFamily: `Greycliff CF, ${theme.fontFamily}`,
          fontWeight: 900,
        })}
      >
        قم بتسجيل المعلومات التالية
      </Title>
      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        <TextInput
          label="الاسم"
          size="lg"
          ref={nameRef}
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
        <TextInput
          label="رقم الهاتف"
          size="lg"
          value={phoneNumber}
          onChange={(e) => {
            setPhoneNumber(e.target.value);
          }}
        />
        <TextInput
          label="العنوان"
          size="lg"
          value={address}
          onChange={(e) => {
            setAddress(e.target.value);
          }}
        />
        <Autocomplete
          label="حالة الشخص"
          required
          size="lg"
          transition="pop-top-left"
          transitionDuration={80}
          transitionTimingFunction="ease"
          value={Flag}
          onChange={(e) => {
            setFlag(e);
          }}
          data={["مفقود", "موجود"]}
          limit={2}
        />
        <TextInput
          label="موقع المركز"
          required
          size="lg"
          value={location}
          onChange={(e) => {
            setLocation(e.target.value);
          }}
        />
        <Button
          fullWidth
          color="cyan"
          variant="gradient"
          gradient={{ from: "blue", to: "teal", deg: 60 }}
          mt="xl"
          size="lg"
          onClick={handleAddPerson}
          style={{
            opacity:
              (location === "") | (Flag === "") | (faceImage === null)
                ? 0.3
                : 1,
          }}
        >
          اضافة
        </Button>
      </Paper>
    </Card>
  );
}

function ShutterImage({
  toggle,
  setToggle,
  setFaceImage,
  setCanDetecae,
  onPlay,
  stopCamera,
  faceImage,
  captureImage,
  startVideo,
  canvasRef,
  videoRef,
}) {


  const searchForBluetoothDevices = useCallback(() => {

    navigator.bluetooth.requestDevice(
      {
        optionalServices: ["battery_service", "device_information"],
        acceptAllDevices: true,
      }
    ).then(function(device) {
      console.log('Name: ' + device.name);
      return device.gatt.getPrimaryService();
    })
    .then(function(service) {
      console.log(service)
      return service.getCharacheteristic('<Your Charachteristic UUID>');
    })
    .then(function(characteristic) {
      console.log('Characteristic: ' + characteristic)
      // Do something with the characteristic
    })
    .catch(function(error) {
      console.log("Something went wrong. " + error);
    });

  });

  return (
    <div style={{ width: 550, marginTop: 144 }}>
      <Card
        shadow="13px 18px 25px #e5e5e5, 1px 3px 3px #e5e5e5, -1px 3px 3px #e5e5e5"
        p="xl"
        radius="md"
      >
        {!toggle && (
          <div className="toggle-button">
            <ThemeIcon
              variant="gradient"
              gradient={{ from: "blue", to: "teal", deg: 60 }}
              size={100}
              radius={50}
              onClick={() => {
                setToggle(!toggle);
                setCanDetecae(true);
                setFaceImage(null);
                startVideo();
              }}
            >
              <CameraPlus size={40} className="faceId-Button" />
            </ThemeIcon>
          </div>
        )}
        {toggle ? (
          <div>
            <div // Dimensions of snaping image relative to the model
              style={{
                width: "500px",
                position: "relative",
                direction: "ltr",
                height: "500px",
              }}
            >
              <video
                id="video"
                width="500"
                height="500"
                autoPlay
                muted
                onPlay={onPlay}
                ref={videoRef}
              ></video>
              <canvas
                ref={canvasRef}
                style={{
                  position: "absolute",
                  width: "500px",
                  height: "500px",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                }}
              ></canvas>
            </div>
            {faceImage && (
              <div
                onClick={() => {
                  setFaceImage(null);
                  setCanDetecae(true);
                  startVideo();
                }}
                className="retry-button"
              >
                <ActionIcon color="blue" size="lg" radius="xl">
                  <Refresh className="refresh-icon" size={33} />
                </ActionIcon>
              </div>
            )}
            {!faceImage && (
              <div onClick={() => captureImage()} className="retry-button">
                <ActionIcon color="blue" size="lg" radius="xl">
                  <Camera className="refresh-icon" size={33} />
                </ActionIcon>
              </div>
            )}
          </div>
        ) : (
          <div // Dimensions of snaping image relative to the model
            style={{
              width: "500px",
              position: "relative",
              height: "500px",
            }}
          />
        )}
      </Card>
    </div>
  );
}
